export default __webpack_public_path__ + "static/media/ufo.2621455a.png";